<template>
  <div class="pa-2">
    <template v-if="filterCouriers.length > 1">
      <v-select
        v-model="couriercode"
        :items="filterCouriers"
        :label="$t('Shipping Method')"
        outline
        :hide-details="hideDetails"
        :error="error"
        :error-messages="errorMessages"
        v-validate="'required'"
        @change="$emit('input', couriercode)"
      ></v-select>
    </template>
    <div v-else-if="filterCouriers.length == 1" class="text-xs-center primary--text">
      {{ filterCouriers[0] ? filterCouriers[0].text : '' }}
    </div>
    <div v-else class="text-xs-center grey--text">ไม่สามารถจัดส่งได้</div>

    <v-chip
      small
      color="red"
      class="white--text"
      disabled
      v-if="currentCourier && currentCourier.price_remote_area"
    >
      <v-icon class="mr-1" small>add</v-icon> พื้นที่ห่างไกล
    </v-chip>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['value', 'couriers', 'hideDetails', 'error', 'errorMessages', 'shippingtype'],
  data() {
    return {
      couriercode: null,
      courierlist: [],
      cod_list: [
        'THP',
        'TP2',
        'ECP',
        'EMST',
        'ECPT',
        'FLE',
        'FLES',
        'SCG',
        'SCGC',
        'SCGF',
        'SCGX',
        'NJV',
        'CJE',
        'APF',
        'TRUE',
        'BEST',
        'BEE',
        'KRYP',
        'KRYD',
        'JWDC',
        'JWDF',
        'ARM',
        'JNTP',
        'JNTD',
        'SPE',
        'SPEC',
        'ZTO',
        'EMSX',
        'EMSXP',
        'MSE',
        'MSEC'
      ]
    }
  },
  computed: {
    filterCouriers() {
      return this.courierlist
        .filter((courier) => {
          return courier.available == true
        })
        .map((el) => {
          if (this.shippingtype == 'cod_charge') {
            if (this.cod_list.includes(el.courier_code)) {
              return {
                text: '(COD) ' + el.courier_name,
                value: el.courier_code
              }
            } else {
              return null
            }
          } else {
            return {
              text: el.courier_name,
              value: el.courier_code
            }
          }
        })
        .filter((el) => {
          return el != null
        })
    },
    currentCourier() {
      return this.courierlist.find((el) => {
        return el.courier_code == this.couriercode
      })
    }
  },
  async mounted() {
    this.couriercode = this.value
    await this.$nextTick()
    this.formatCouriers()
  },
  methods: {
    formatCouriers() {
      var couriers = []

      for (var courier in this.couriers) {
        if (this.couriers.hasOwnProperty(courier)) {
          couriers.push(this.couriers[courier])
        }
      }

      var filterCouriers = couriers
        .filter((courier) => {
          return courier.available == true
        })
        .map((el) => {
          if (this.shippingtype == 'cod_charge') {
            if (this.cod_list.includes(el.courier_code)) {
              return el
            } else {
              return null
            }
          } else {
            return el
          }
        })
        .filter((el) => {
          return el != null
        })

      if (filterCouriers.length == 1) {
        this.couriercode = filterCouriers[0].courier_code
        this.$emit('input', this.couriercode)
      }

      this.courierlist = couriers
    }
  },
  watch: {
    couriers(newVal, oldVal) {
      if (newVal != oldVal) {
        this.formatCouriers()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SelectShippopCourier.vue